// ✅ Trekkin.app — CloseButton.jsx v1.5.0 (SAFE TOAST)
// -------------------------------------------------------------
// ✔ Nunca passa objetos ao toast
// ✔ Totalmente neutro
// -------------------------------------------------------------

import { showToast } from "./NotifyToast.jsx";
import { usePanelsStore } from "../stores/usePanelsStore.jsx";

export default function CloseButton({ onClick, ariaLabel = "Fechar" }) {
  const handleClick = () => {
    const panels = usePanelsStore.getState();
    panels.beginPanelCloseAction?.();
    try {
      if (typeof onClick === "function") onClick();
      else panels.closePanel?.();
    } catch (e) {
      showToast({
        type: "error",
        message: "Erro ao fechar painel",
      });
    } finally {
      panels.endPanelCloseAction?.();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="tk-close-button"
      aria-label={ariaLabel}
    >
      ✕
    </button>
  );
}
